export const BLACK = 'black';
export const WHITE = 'white';